import { memo } from 'react'
import { Box } from '@mui/material'
import { Link } from '@reach/router'
import { t } from 'i18next'
import InfoBar from 'src/components/shared/ui/InfoBar/InfoBar'
import { ESCRITOS_LEXNET } from 'src/constants/routes'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { TipoMensaje, TipoMensajeURLPath } from 'src/enums/EscritosLegales'

const styles = {
  fontWeight: 'bold',
  textDecoration: 'underline'
}

function PersonacionInfoBar() {
  const { changeTipoMensaje } = useTipoMensajeContext()

  function handleClick() {
    changeTipoMensaje(TipoMensaje.ESCRITO)
  }

  function Message(): JSX.Element {
    return (
      <>
        {t('components.info_bar_personacion.text')}{' '}
        <Link to={ESCRITOS_LEXNET(TipoMensajeURLPath.TRAMITE)} onClick={handleClick}>
          <span style={styles}>{t('components.info_bar_personacion.link')}</span>
        </Link>
      </>
    )
  }

  return (
    <Box sx={{ marginTop: '24px' }}>
      <InfoBar message={<Message />} showCloseIcon={false} />
    </Box>
  )
}

export default memo(PersonacionInfoBar)
